import { render, staticRenderFns } from "./Homeworks.vue?vue&type=template&id=3025e0d8&"
import script from "./Homeworks.vue?vue&type=script&lang=js&"
export * from "./Homeworks.vue?vue&type=script&lang=js&"
import style0 from "./Homeworks.vue?vue&type=style&index=0&id=3025e0d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports